module.exports = __webpack_public_path__ + "static/media/Olive-Green_2.c40ab0ff.jpg";